import Vue from 'vue';

const Bus = new Vue();
Vue.prototype.$$trigger = function(event, ...args) {
    return Bus.$emit(event, args);
};
Vue.prototype.$$bind = function(event, callback) {
    return Bus.$on(event, callback);
};
Vue.prototype.$$unbind = function(event, callback) {
    return Bus.$off(event, callback);
};

export default Bus;
